// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinnerWrapper--jSBXh {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinnerWrapperCover--xdwKS {
  position: absolute;
  top: 0;
  z-index: 999999;
}

[dir] .spinnerWrapperCover--xdwKS {
  background-color: white;
}

[dir=ltr] .spinnerWrapperCover--xdwKS {
  left: 0;
}

[dir=rtl] .spinnerWrapperCover--xdwKS {
  right: 0;
}

.spinner--pRxKS {
  width: 50px;
  height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/LoadingSpinner/styles.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EAEN,eAAe;AAEjB;;AANA;EAKE,uBAAuB;AACzB;;AANA;EAGE,OAAO;AAGT;;AANA;EAGE,QAAO;AAGT;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".spinnerWrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spinnerWrapperCover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 999999;\n  background-color: white;\n}\n\n.spinner {\n  width: 50px;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinnerWrapper": `spinnerWrapper--jSBXh`,
	"spinnerWrapperCover": `spinnerWrapperCover--xdwKS`,
	"spinner": `spinner--pRxKS`
};
export default ___CSS_LOADER_EXPORT___;
